import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../store/utils/hooks'
import { selectOnboardingData } from '../../../store/slices/user/userSlice'
import { ONBOARDING_PATH } from '../../../routes/OnboardingRoutes'
import urlBuilder from '../../../utils/UrlBuilder'

export const useOnboardingProgress = (requiredStep: string, redirectPath: string) => {
	const navigate = useNavigate()
	const onboardingData = useAppSelector(selectOnboardingData)

	useEffect(() => {
		const hasCompletedStep = checkStepCompletion(requiredStep, onboardingData)

		if (!hasCompletedStep) {
			navigate(urlBuilder([ONBOARDING_PATH, redirectPath]), { replace: true })
		}
	}, [onboardingData, navigate, requiredStep, redirectPath])

	return checkStepCompletion(requiredStep, onboardingData)
}

const checkStepCompletion = (step: string, data: any) => {
	switch (step) {
		case 'register':
			return !!data?.email
		default:
			return false
	}
}
